import React, { memo } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Close from '@mui/icons-material/Close';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import Download from '@mui/icons-material/Download';
import { smallPillButtonSx } from './styles';

interface SelectionToolbarProps {
  count: number;
  downloadableCount: number;
  busy: boolean;
  onClear: () => void;
  onDownload: () => void;
  onDelete: () => void;
}

const SelectionToolbar: React.FC<SelectionToolbarProps> = ({ count, downloadableCount, busy, onClear, onDownload, onDelete }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%', py: 1 }}>
    <IconButton aria-label="Clear selection" onClick={onClear} sx={{ color: 'primary.dark' }}>
      <Close fontSize="small" />
    </IconButton>
    <Typography sx={{ fontWeight: 600, color: 'primary.dark' }}>{count} selected</Typography>
    <Box sx={{ ml: 'auto', display: 'flex', gap: 1 }}>
      <Button
        variant="outlined"
        startIcon={<Download />}
        onClick={onDownload}
        disabled={busy || downloadableCount === 0}
        title={downloadableCount === 0 ? 'None of the selected jobs have files yet' : undefined}
        sx={smallPillButtonSx}
      >
        Download files
      </Button>
      <Button variant="outlined" color="error" startIcon={<DeleteOutline />} onClick={onDelete} disabled={busy} sx={smallPillButtonSx}>
        Delete
      </Button>
    </Box>
  </Box>
);

export default memo(SelectionToolbar);
